export const VERSION = '25.05.1'